export const CANCEL_REASON_CATEGORIES = [
  {
    value: 'fondos_insuficientes',
    label: 'Fondos insuficientes',
  },
  {
    value: 'rechazo_cliente',
    label: 'Rechazo del cliente',
  },
];

export const CANCEL_REASON_CATEGORY_MAP = CANCEL_REASON_CATEGORIES.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});
